export const ENGLISH_LANGS = ["en", "en-GB", "en-US"];

export class LanguageObserver {
  private htmlElement: HTMLElement;
  private observer: MutationObserver | null;

  constructor() {
    this.htmlElement = document.documentElement;
    this.observer = null;
  }

  displayTranslationWarning() {
    if (this.htmlElement.lang && !ENGLISH_LANGS.includes(this.htmlElement.lang)) {
      // eslint-disable-next-line no-alert
      alert(
        "For a smoother experience on our website, please disable translation."
      );
    }
  }

  // Start observing changes to the 'lang' attribute
  startObserving() {
    this.observer = new MutationObserver(() => {
      this.displayTranslationWarning();
    });

    this.observer.observe(this.htmlElement, {
      attributes: true,
      attributeFilter: ["lang"], // Watch only the 'lang' attribute
    });

    // Initial check on module load
    this.displayTranslationWarning();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const languageObserver = new LanguageObserver();

  if (window.static_data.feature_flags.warn_customers_about_translating_website) {
    languageObserver.startObserving();
  }
});
